import React, { useState } from 'react';
import '../../styles/AdminLogin.css';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { app } from '../../firebase'; 
import { Eye, EyeOff } from 'lucide-react'; 
import { useNavigate } from 'react-router-dom'; // <-- import navigate

const auth = getAuth(app);
const db = getFirestore(app);

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate(); // <-- initialize navigate

  const togglePassword = () => {
    setShowPass(!showPass);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const uid = userCredential.user.uid;

      const userDoc = await getDoc(doc(db, 'users', uid));
      if (userDoc.exists() && userDoc.data().role === 'admin') {
        navigate('/admin/dashboard'); // <-- navigate to dashboard
      } else {
        setError('You are not authorized to access this area.');
        auth.signOut();
      }
    } catch (err) {
      setError('Invalid credentials or user not found.');
    }

    setLoading(false);
  };

  return (
    <div className="admin-login-container">
      <form className="admin-login-card" onSubmit={handleLogin}>
        <h2 className="admin-login-title">Admin Login</h2>
        <div className="admin-form-group">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="admin-input"
          />
          <label className="admin-label">Email</label>
        </div>
        <div className="admin-form-group">
          <input
            type={showPass ? 'text' : 'password'}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="admin-input"
          />
          <label className="admin-label">Password</label>
          <span className="toggle-eye" onClick={togglePassword}>
            {showPass ? <EyeOff size={20} /> : <Eye size={20} />}
          </span>
        </div>
        {error && <div className="admin-error">{error}</div>}
        <button className="admin-login-btn" disabled={loading}>
          {loading ? 'Signing in...' : 'Login'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
